var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _vm._l(_vm.disclaimerSection.htmlDescriptionArray, function(item, index) {
        return _c("li", {
          key: _vm.disclaimerSection.id + index,
          attrs: { value: item },
          domProps: { innerHTML: _vm._s(item) }
        })
      }),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("span", [_vm._v("You agree to Frontier")]),
          _vm._v(" "),
          _c(
            "f9link",
            {
              staticClass: "hyperlink-force-pointer-events",
              attrs: {
                underline: true,
                href: "https://www.flyfrontier.com/legal/privacy-policy",
                target: "_blank"
              }
            },
            [_vm._v("\n            Privacy Policy\n        ")]
          ),
          _vm._v("\n        and\n        "),
          _c(
            "f9link",
            {
              staticClass: "hyperlink-force-pointer-events",
              attrs: {
                underline: true,
                href:
                  "https://www.flyfrontier.com/legal/california-privacy-policy#Financial%20Incentive%20Programs",
                target: "_blank"
              }
            },
            [_vm._v("\n            California Privacy Policy\n        ")]
          ),
          _vm._v(".\n    ")
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d1478bf", { render: render, staticRenderFns: staticRenderFns })
  }
}